import { render, staticRenderFns } from "./BeADistributor.vue?vue&type=template&id=05461f4f&scoped=true"
import script from "./BeADistributor.vue?vue&type=script&lang=ts"
export * from "./BeADistributor.vue?vue&type=script&lang=ts"
import style0 from "./BeADistributor.vue?vue&type=style&index=0&id=05461f4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05461f4f",
  null
  
)

export default component.exports